import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Custom Components
import { StudentProgressComponent } from './student-progress.component';

const studentProgressRoutes: Routes = [
  { path: '', component: StudentProgressComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(studentProgressRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class StudentProgressRoutingModule { }
